import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import PageMeta from '../components/PageMeta';
import { useAuthContext } from '../context/AuthContext';

const LoginPage = () => {
  const [loginId, setLoginId] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [rememberMe, setRememberMe] = useState<boolean>(false);
  const { login } = useAuthContext();
  const [error_message, setErrorMessage] = useState<string>();
  const navigator = useNavigate();
  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    const res = await login(loginId, password, rememberMe)
    if (res.success === true) {
      navigator(res.role === 'system' ? '/system-admin' : '/admin')
    } else {
      setErrorMessage('IDかパスワードが間違っています。')
    }
  };

  return (
    <div className="bg-gray-100 flex justify-center items-center min-h-screen px-4 py-8">
      <PageMeta title="ログイン" noIndex />
      <div className="bg-white p-6 sm:p-8 rounded-lg shadow-md w-full max-w-md">
        <h2 className="text-2xl text-gray-800 font-semibold mb-6 text-center">ログイン</h2>
        <form onSubmit={handleSubmit} method="POST">
            <div className="mb-4">
              <label htmlFor="loginId" className="block text-gray-700 text-sm font-bold mb-2">ID</label>
              <input type="text" id="loginId" value={loginId} onChange={(e) => setLoginId(e.target.value)} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="IDを入力してください" required />
            </div>
            <div className="mb-4">
              <label htmlFor="password" className="block text-gray-700 text-sm font-bold mb-2">パスワード</label>
              <input type="password" id="password" value={password} onChange={(e) => setPassword(e.target.value)} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" placeholder="パスワードを入力してください" required />
            </div>
            <div className="mb-6">
              <label className="flex items-center gap-2 cursor-pointer select-none">
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                  className="w-4 h-4 rounded border-gray-300 text-blue-500 focus:ring-blue-400"
                />
                <span className="text-sm text-gray-600">ログインしたままにする</span>
              </label>
            </div>
            <div className='text-red-500 text-[14px] mb-2'>{error_message}</div>
            <button type="submit" className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full">ログイン</button>
            <p className="mt-4 text-center">
              <Link
                to="/login/forgot-password"
                className="text-sm text-blue-600 hover:text-blue-800 hover:underline"
              >
                パスワードをお忘れの方
              </Link>
            </p>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
